import React, { useState, useEffect } from "react";
import {
  FormStyle,
} from "../../login/components/RightSideContainer";
import { Button } from "../../../components/Button";
import { EKYC_SET_PASSWORD_TITLE } from "./constant";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import ROUTES, { EKYC } from "../../../helpers/constants/routes";
import { MobileTextBox } from "../../../components/MobileTextBox";
import { getDeviceType } from "../../../utils/CommonFunction";
import { DeviceType } from "../../../helpers/constants/constant";
import FooterMobile from "../../login/components/FooterMobile";
import { triggerSimpleAjax } from "../../../helpers/httpHelper.js";
import { CHANGE_PASSWORD_API } from "../../../helpers/constants/ekycApiUrl.js";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { black500 } from "../../../theme/colors.js";
import CommonInput from "../../login/componentLoginScreen/CommonInput";

const SetAccountPassword = () => {
  const history = useHistory();
  const [isPasswordField, setIsPasswordField] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const PasswordIcon = showPassword ? VisibilityOffIcon : VisibilityIcon;
  const ConfirmPasswordIcon = showConfirmPassword
    ? VisibilityOffIcon
    : VisibilityIcon;
  const [data, setData] = React.useState({
    password: "",
    confirmPassword: "",
    userPhoneNumber: "",
    username: "",
    token: "",
    isError: false,
    errorObj: {},
    isLoading: false,
    isSessionClear: false,
    mobileView: false,
  });

  useEffect(() => {
    console.log(
      "history in set account password",
      localStorage.getItem("sessionid"),
    );
    const mobileView =
      getDeviceType() === DeviceType.MOBILE ||
      getDeviceType() === DeviceType.TABLET;

    const stateData = history?.location?.state || {};
    console.log("stateDatastateDatastateData",JSON.stringify(stateData))

    setData((prev) => ({
      ...prev,
      mobileView: mobileView,
      username: stateData?.name || "",
      userPhoneNumber: stateData?.phone || "",
      token: stateData?.token || stateData?.sessionid,
    }));

    const sessionData = JSON.parse(localStorage.getItem("451")) || {};
    if (Object.keys(sessionData).length) {
      setData((prev) => ({
        ...prev,
        isSessionClear: true,
        isError: true,
        errorObj: {
          ...sessionData,
        },
      }));

      localStorage.removeItem("451");
    }
  }, []);

  const onChangeAction = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const navigateToCouponLogin = (e) => {
    e && e.preventDefault();
    // history.push(EKYC.LOGIN);
  };

  const validatePassword = (password) => {
    const validationErrors = [];

    if (password.length < 8) {
      validationErrors.push("Password must be at least 8 characters");
    }
    if (!/[A-Z]/.test(password)) {
      validationErrors.push("Password must contain at least 1 uppercase letter");
    }
    if (!/[0-9]/.test(password)) {
      validationErrors.push("Password must contain at least 1 number");
    }
    if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
      validationErrors.push("Password must contain at least 1 special character");
    }

    return validationErrors.length ? validationErrors.join(". ") : null;
  };

  const handleSetPassword = () => {
    const { password, confirmPassword } = data;

    let errors = {};

    if (!password) {
      errors.password = "Password is required";
    }

    if (!confirmPassword) {
      errors.confirmPassword = "Confirm password is required";
    }

    if (password) {
      const passwordErr = validatePassword(password);
      if (passwordErr) {
        errors.password = passwordErr;
      }
    }

    if (password && confirmPassword && password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }

    if (Object.keys(errors).length > 0) {
      setData((prev) => ({
        ...prev,
        isError: true,
        errorObj: errors,
      }));
      return;
    }

    setData((prev) => ({ ...prev, isLoading: true }));
     const payload={
        password: data.password,
        confirm_password: data.confirmPassword,
        token: data.token,
      }
      console.log("kjnkjsdjdsjfsjkds",JSON.stringify(payload))
    triggerSimpleAjax(
      CHANGE_PASSWORD_API,
      "POST",
      {
        password: data.password,
        confirm_password: data.confirmPassword,
        token: data.token,
      },
      (response) => {
        console.log("Password set successfully", response);

        setData((prev) => ({
          ...prev,
          isLoading: false,
          isError: false,
        }));

        if (data.mobileView) {
          history.push(EKYC.PASSWORD_SUCCESS);
        } else {
         window
            .swal({
              title: "Login Successful!",
              text: "Welcome to the dashboard.",
              icon: "success",
              button: false,
              timer: 2000,
            })
            .then(() => {
              history.push(EKYC.LOGIN);
            });
        }
      },
      (error) => {
        console.log("Failed to set password", error);

        setData((prev) => ({
          ...prev,
          isLoading: false,
          isError: true,
          errorObj: {
            password: error?.password?.[0],
            confirmPassword: error?.confirm_password?.[0],
            token: error?.token?.[0],
          },
        }));
      },
    );
  };

  const switchField = (e) => {
    e && e.preventDefault();
    setIsPasswordField((prev) => !prev);
  };

  return data.mobileView ? (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "90%",
          maxWidth: "440px",
          padding: "2.5rem 1.5rem",
          marginTop: "-30px",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.05)",
          zIndex: 2,
        }}
      >
        <h3 style={{ fontSize: 18, fontWeight: "600", color: "#333", marginBottom: "8px" }}>Create Password 👋</h3>
        <p style={{ padding: 0, margin: "0 0 15px 0", fontSize: 14, color: "#666", textAlign: "center" }}>
          {EKYC_SET_PASSWORD_TITLE}
        </p>
        <FormStyle style={{ width: "100%" }}>
          <MobileTextBox
            labelName="Enter Password"
            placeholder="Enter Password"
            name="password"
            value={data.password}
            type={showPassword ? "text" : "password"}
            onChange={onChangeAction}
            error={data.isError}
            errorMessage={data.errorObj?.password}
            rightIcon={{
              icon: (
                <PasswordIcon
                  style={{
                    color: black500,
                    marginRight: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowPassword((prev) => !prev)}
                />
              ),
            }}
            showHint={true}
          />
          <MobileTextBox
            labelName="Confirm Password"
            placeholder="Confirm Password"
            name="confirmPassword"
            value={data.confirmPassword}
            type={showConfirmPassword ? "text" : "password"}
            onChange={onChangeAction}
            error={data.isError}
            errorMessage={data.errorObj?.confirmPassword}
            rightIcon={{
              icon: (
                <ConfirmPasswordIcon
                  style={{
                    color: black500,
                    marginRight: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                />
              ),
            }}
          />
          <Button
            type="submit"
            onClick={handleSetPassword}
            isLoading={data.isLoading}
            width="100%"
            bgColor="#4770C1"
            borderRadius="8px"
            fontStyle={{ fontSize: "14px", marginTop: "35px" }}
            boxHeight="38px"
          >
            {data.isSessionClear ? "Logout All Session" : "Proceed"}
          </Button>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              marginTop: "35px",
            }}
          >
            <p style={{ margin: 0, fontSize: "15px", color: "#666" }}>Return To</p>

            <span
              onClick={navigateToCouponLogin}
              style={{
                fontSize: "15px",
                color: "#4770C1",
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Login
            </span>
          </div>
        </FormStyle>
      </div>

      <div style={{ alignItems: "center", marginTop: "20px", width: "90%", maxWidth: "440px" }}>
        <FooterMobile textStyle="small" showSecuritySection={true} />
      </div>
    </>
  ) : (
    <form className="login-Form" onSubmit={(e) => { e.preventDefault(); handleSetPassword(); }}>
      <h2 className="login-heading" style={{ marginBottom: 20 }}>
        Create Password 👋
      </h2>
      <p style={{ color: "#777", marginBottom: 30, fontSize: "16px", fontFamily: "barlow" }}>
        {EKYC_SET_PASSWORD_TITLE}
      </p>

      <CommonInput
        type="password"
        label="Password"
        name="password"
        value={data.password}
        onChange={onChangeAction}
        error={data.isError ? data.errorObj?.password : ""}
        showToggle={true}
        showHint={true}
        autoFocus
      />

      <CommonInput
        type="password"
        label="Confirm Password"
        name="confirmPassword"
        value={data.confirmPassword}
        onChange={onChangeAction}
        error={data.isError ? data.errorObj?.confirmPassword : ""}
        showToggle={true}
      />

      <div
        style={{
          width: "70%",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "45px",
          alignItems: "center",
        }}
      >
        <button
          className="next-button"
          type="submit"
          disabled={data.isLoading}
        >
          {data.isSessionClear ? "Logout All Session" : "Proceed"}
        </button>
      </div>
    </form>
  );
};
export default SetAccountPassword;
